import { render, staticRenderFns } from "./filter-group.vue?vue&type=template&id=472c961e"
import script from "./filter-group.vue?vue&type=script&lang=js"
export * from "./filter-group.vue?vue&type=script&lang=js"
import style0 from "./filter-group.vue?vue&type=style&index=0&id=472c961e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports